import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import awardLevels from './../../constants/award-levels.constants'
import { makeAutoObservable, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit'
import { UserFactory, EliteAgencyTeamFactory } from './../../shared/factories'
import PIPAwardLevel from './../../shared/utilities/PipAwardLevel.class'

import './AgentAwardLevel.scss'

class PerformanceStore {
  isFetching = false
  User = null
  pipLevel = null

  constructor() {
    makeAutoObservable(this)
  }

  setUser = async userId => {
    this.isFetching = true
    const hasChanged = `${userId}` !== `${this.User?.id()}`
    this.User = (userId && (await UserFactory.findById(userId))) || null
    if (this.User && hasChanged) {
      const Team = (
        (
          await EliteAgencyTeamFactory.search({
            search: { owner_id: this.User.id() },
          })
        )?.models || []
      ).shift()
      this.pipLevel = await this.User[Team ? 'getTeamPipLevel' : 'getPipLevel']()
    }
    this.isFetching = false
  }
}

export const Store = new PerformanceStore()

const AgentAwardLevel = observer(({ userId }) => {
  const history = useHistory(),
    { setUser, User, pipLevel } = Store,
    { level, max, min, name, points } = pipLevel || {},
    currYear = new Date().getFullYear(),
    [awardLevel, setAwardLevel] = useState(null)

  useEffect(() => {
    setUser(userId)
  }, [userId])

  useEffect(() => {
    setAwardLevel(awardLevels.find(a => parseInt(a.level) === parseInt(level)))
  }, [level])

  const img = points ? (
    PIPAwardLevel.getUsertypeAwardBadge(
      92,
      (`${points}` || 0).replace(/[^\d]/g, ''),
      { size: '65px', display: 'block', margin: 'auto' },
      'sig_agent',
      true
    )
  ) : (
    <></>
  )

  if (level) {
    return (
      <div id='AgentAwardLevelComponent' onClick={() => history.push('/leaderboards')}>
        <div className='img-wrapper'>{img}</div>
        <div className='label-wrapper'>Level {level}</div>
      </div>
    )
  }

  return <></>
})

export default AgentAwardLevel
